module.exports = __webpack_public_path__ + "img/bg_7.d91d9d51.jpg";